import * as types from '../actions/action-types';

const initialState = {
  walletDetails: {},
};

export default (state = initialState, action) => {
  if (action.type === types.UPDATE_ALIPAY_PLUS_WALLET_DETAILS) {
    return {
      ...state,
      walletDetails: {
        ...action.details,
      },
    };
  }
  return state;
};
